// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  display: block;
  position: relative;
  min-width: 0;
}

ag-grid-angular {
  width: 100%;
}
ag-grid-angular::ng-deep .ag-row-hover app-table-cell-actions-panel {
  display: flex;
}
ag-grid-angular::ng-deep app-table-cell-actions-panel {
  display: none;
}

ag-grid-angular.main {
  flex: 1 1;
  min-height: 0;
  display: inherit;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/shared/table/table/table.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;AACF;AACE;EACE,aAAA;AACJ;AAEE;EACE,aAAA;AAAJ;;AAIA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AADF","sourcesContent":[":host {\n  width: 100%;\n  display: block;\n  position: relative;\n  min-width: 0;\n}\n\nag-grid-angular {\n  width: 100%;\n\n  &::ng-deep .ag-row-hover app-table-cell-actions-panel {\n    display: flex;\n  }\n\n  &::ng-deep app-table-cell-actions-panel {\n    display: none;\n  }\n}\n\nag-grid-angular.main {\n  flex: 1 1;\n  min-height: 0;\n  display: inherit;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
